module.exports = __webpack_public_path__ + "img/bg-image-2.34302376.png";